import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Market } from 'src/app/models/market'
import { MarketService } from 'src/app/services/market.service'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  markets: any

  constructor(public router: Router, 
    public marketService: MarketService
  ) {
    
  }

  ngOnInit(): void {
    this.marketService.getAllMarket().subscribe( 
      (markets) => {
        this.markets = markets
      }
    )
  }

  createMarket() {
    this.router.navigate(['marche/creation'])
  }

  triggerRefresh(markets: any) {
    this.markets = markets
  }
}
